import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Menubar } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [Menubar],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  menuItems: MenuItem[] = [];
  username: string = '';

  constructor(
    private http: HttpClient,
    private keycloak: KeycloakService,
  ) {}

  ngOnInit(): void {
    this.loadUsername();
  }

  private loadUsername(): void {
    this.http.get<{ acronym: string, username: string }>('/api/v1/me').subscribe({
      next: res => {
        this.username = res.acronym || res.username;
        this.initMenuItems();
      },
      error: () => {
        this.username = '';
        this.initMenuItems();
      }
    });
  }

  private initMenuItems(): void {
    this.menuItems = [
      {
        label: 'Skills',
        items: [
          { label: 'People', routerLink: '/skillmap/table' },
          { label: 'Overview', routerLink: '/skillmap/graph' },
          { label: 'Learning', routerLink: '/skillmap/graph-learning' },
          { label: 'Preferences', routerLink: '/skillmap/graph-like' },
        ]
      },
      {
        label: 'Teams',
        items: [
          { label: 'Create team', routerLink: '/skillmap/create-team' },
          { label: 'Team skills', routerLink: '/skillmap/teams' },
          { label: 'Teams list', routerLink: '/skillmap/active-teams' },
          { label: 'Team matcher', routerLink: '/skillmap/team-matcher' },
        ]
      },
      {
        label: 'Uploads',
        items: [
          { label: 'Uploaded files', routerLink: '/skillmap/upload-list' },
          { label: 'Upload XLS', routerLink: '/skillmap/upload' },
        ]
      },
      {
        label: 'u:' + this.username,
        items: [
          {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            command: () => this.logout(),
          },
        ]
      }
    ];
  }

  logout(): void {
    this.keycloak.logout(window.location.origin + '/');
  }
}
